module.exports = __webpack_public_path__ + "static/media/championshipTrophy.c9a1e85d.svg";